<script>
// digitt: DENG-7340 — render callback actions as a real Chatwoot button.
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { NextButton },
  props: {
    message: { type: String, default: '' },
    action: {
      type: Object,
      default: () => {},
    },
  },
  // digitt: DENG-7340 — let a callback action close the toast after running.
  emits: ['dismiss'],
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
  mounted() {},
  methods: {
    // digitt: DENG-7340 — hand the action a `dismiss` command; the caller decides whether to
    // close the toast (some actionables shouldn't). The snackbar never closes on its own.
    onActionClick() {
      this.action?.onClick?.(() => this.$emit('dismiss'));
    },
  },
};
</script>

<template>
  <div>
    <div
      class="shadow-sm bg-n-slate-12 dark:bg-n-slate-7 rounded-lg items-center gap-3 inline-flex mb-2 max-w-[25rem] min-h-[1.875rem] min-w-[15rem] px-6 py-3 text-left"
    >
      <div class="text-sm font-medium text-white dark:text-white">
        {{ message }}
      </div>
      <div v-if="action">
        <router-link
          v-if="action.type == 'link'"
          :to="action.to"
          class="font-medium cursor-pointer select-none text-n-blue-10 hover:text-n-brand"
        >
          {{ action.message }}
        </router-link>
        <!-- digitt: DENG-7340 — generic callback action rendered as a Chatwoot button. -->
        <NextButton
          v-else-if="action.type == 'actionable'"
          :label="action.message"
          variant="faded"
          color="blue"
          size="sm"
          @click="onActionClick"
        />
      </div>
    </div>
  </div>
</template>
